import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

/**
 * Client-side env, validated the same way every server app in the repo
 * validates its own (`@t3-oss/env-core` + Zod) — see CLAUDE.md → Conventions.
 * `clientPrefix: 'VITE_'` is env-core's documented seam for bundlers that
 * inline `import.meta.env` at build time (Vite only ever exposes `VITE_*`
 * keys to client code, so there is no server-only shape to declare here).
 */
export const env = createEnv({
  clientPrefix: 'VITE_',
  client: {
    VITE_ADMIN_API_URL: z.string().url().default('http://127.0.0.1:3100'),
  },
  runtimeEnv: import.meta.env,
});
